import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_MERCHANT_SETTINGS_ROUTE_NAME, MERCHANT_SETTINGS_PERMISSIONS } from '@modules/merchant-settings/constants';

import {
  ADMIN_MERCHANT_SETTINGS_EDIT_ROUTE_NAME,
  TRANSLATION_GROUP_MERCHANT_SETTINGS_EDIT,
} from './constants';
import { getTranslationKeys } from './translations';

export class MerchantSettingsEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_MERCHANT_SETTINGS_ROUTE_NAME, {
      name: ADMIN_MERCHANT_SETTINGS_EDIT_ROUTE_NAME,
      path: 'edit/:id',
      permission: MERCHANT_SETTINGS_PERMISSIONS.SHOW,
      component: () => import('./pages/MerchantSettingsEditPage/MerchantSettingsEditPage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_MERCHANT_SETTINGS_EDIT, getTranslationKeys);
  }
}
